import React from 'react';
import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import { I18nText, Avatar } from '@welldev-group/react-comp-lib';

import TicketStatus from './TicketStatus';

const SupportTicketCard = props => {
  const { supportTicket, selectedTicketId, setSelectedTicketId } = props;

  const updatedAt = new Date(supportTicket.updatedAt);
  const updatedAtDate = updatedAt.getDate();

  const updatedAtMonth = updatedAt.toLocaleString(I18n.locale, {
    month: 'short',
  });
  const updatedAtTime = updatedAt.toLocaleTimeString(I18n.locale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  const selected = selectedTicketId === supportTicket.id;

  return (
    <div className="support-ticket-card-wrapper">
      <div
        className={ClassNames('support-ticket-card', {
          'support-ticket-card--selected': selected,
          'support-ticket-card--highlighted':
            !selected && supportTicket.hasNewMessagesForCurrentUser,
        })}
        onClick={() => setSelectedTicketId(supportTicket.id)}
        role="presentation"
      >
        <div className="support-ticket-card__status-subject-wrapper">
          <div className="grid no-wrap">
            <div className="col-5 col-bleed-y col-bleed support-ticket-card__status">
              <TicketStatus state={supportTicket.state} />
            </div>
            <div
              className={ClassNames(
                'col-7 col-bleed-y support-ticket-card__updated-at',
                {
                  'support-ticket-card__user-info--highlighted':
                    !selected && supportTicket.hasNewMessagesForCurrentUser,
                },
              )}
            >
              {' '}
              <I18nText id="support.updated_on" returnStringOnly={true} />{' '}
              {`${updatedAtDate} ${updatedAtMonth} ${updatedAtTime}`}
            </div>
          </div>
        </div>
        <div className="col-12 col-bleed-y support-ticket-card__subject">
          {supportTicket.subject}
        </div>
        <div
          className={ClassNames(
            'col-12 col-bleed-y support-ticket-card__created-by',
            {
              'support-ticket-card__created-by--highlighted':
                !selected && supportTicket.hasNewMessagesForCurrentUser,
            },
          )}
        >
          <I18nText id="support.created_by_user" /> -{' '}
          {supportTicket.createdBy.name}
        </div>
        <div
          className={ClassNames(
            'col-12 col-bleed-y support-ticket-card__organization-source',
            {
              'support-ticket-card__organization-source--highlighted':
                !selected && supportTicket.hasNewMessagesForCurrentUser,
            },
          )}
        >
          <I18nText id="support.from_organization_source" /> -{' '}
          {supportTicket.affiliate.clientName}
        </div>
        {supportTicket.assignedTo ? (
          <div className="support-ticket-card__info">
            <div
              className={ClassNames('support-ticket-card__user-info', {
                'support-ticket-card__user-info--highlighted':
                  !selected && supportTicket.hasNewMessagesForCurrentUser,
              })}
            >
              <Avatar
                src={supportTicket.assignedTo.avatarUid}
                firstName={supportTicket.assignedTo.firstName || ''}
                lastName={supportTicket.assignedTo.lastName || ''}
                size="tiny"
              />
              {(supportTicket.assignedTo.firstName ||
                supportTicket.assignedTo.lastName) &&
                `${supportTicket.assignedTo.firstName} ${supportTicket.assignedTo.lastName}`}
            </div>
          </div>
        ) : (
          <div
            className={ClassNames('col-12 support-ticket-card__no-assignee', {
              'support-ticket-card__no-assignee--highlighted':
                !selected && supportTicket.hasNewMessagesForCurrentUser,
            })}
          >
            <I18nText id="support.unassigned_text" />
          </div>
        )}
      </div>
    </div>
  );
};

SupportTicketCard.defaultProps = {
  selectedTicketId: null,
};

SupportTicketCard.propTypes = {
  selectedTicketId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setSelectedTicketId: PropTypes.func.isRequired,
  supportTicket: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    affiliate: PropTypes.shape({
      clientName: PropTypes.string,
    }),
    hasNewMessagesForCurrentUser: PropTypes.bool.isRequired,
    subject: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    state: PropTypes.string,
    createdBy: PropTypes.shape({
      name: PropTypes.string,
    }),
    assignedTo: PropTypes.shape({
      avatarUid: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
  }).isRequired,
};

export default SupportTicketCard;
